
import { ISubscription } from 'rxjs/Subscription';
import { AuthService, User } from './../user/auth.service';


import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import {
  Component,
  OnInit,
  NgZone,
  ViewEncapsulation,
  AfterViewInit,
  OnDestroy,
  AfterContentInit,
  OnChanges,
  SimpleChanges} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl
} from '@angular/forms';
import { CustomValidatorsService } from '../shared/validators.service';
import { Gift } from '../gift/gift';
import { RegistryService } from '../registry/registry.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { UnsplashImageService } from '../unsplash/unsplash.service';
import { Result } from '../unsplash/unsplash.response';
import { ConfigurationService } from '../shared/configuration.service';
import { IImageItem } from '../create-gift/ICategoryImages';
import { Subject } from 'rxjs/Subject';
import { UserService } from '../user/user.service';
import { AnalyticsService } from '../analytics/analytics.service';
import 'rxjs/add/operator/debounceTime';
import { ToastType } from '../toast/toast.enum';
import { Registry } from '../registry/registry';
import 'rxjs/add/operator/takeUntil';
import { Intercom } from 'ng-intercom';
import { Http, ResponseContentType } from '@angular/http';
import { UploadService } from '../uploads/shared/upload.service';
import { Image } from '../unsplash/image-results';
import { TemplateGift } from '../templates/starter-registry';
import { SettingsStateStore } from '../settings/settings.state.store';
import { Settings } from '../settings/settings';
// ImagePipe
@Component({
  selector: 'app-create-gift',
  encapsulation: ViewEncapsulation.Emulated,
  templateUrl: './create-gift.component.html',
  styleUrls: ['./create-gift.component.scss'],
  providers: [AuthGuard],
  host: {
    '(document:keydown)': 'handleKeyboardEvents($event)'
  }
})
export class CreateGiftComponent implements OnInit, AfterContentInit, OnDestroy, OnChanges {
  user: User;
  oldPrice: number;
  images: Image[];
  masterGiftTemplates: TemplateGift[];
  searchType = 'Photos';
  loadingMore: boolean;
  mode = 'unsplash';
  noMore = false;
  registry: Registry;
  disablePrice = false; 
  errorMessagePrice = "";
  lowestAllowedPortionsToSave:number = 1;
  giftTypeSelection = 'Cash Fund';
  croppping = false;
  showWebsite = false;
  selectedimageBase64: ArrayBuffer;
  previousGift: Gift;
  public hitchdForm: FormGroup;
  public category: string;
  hasPayments = false;
  public selectingImage: boolean;
  //images: ICategoryImages;
  titleExists = false;
  filteredImages: IImageItem[];
  previousImage: IImageItem;
  public gift: Gift;
  public gifts: Gift[];
  categories: Array<string>;
  baseUrl: string;
  public loaded: boolean;
  imageCategory: string;
  submitting: boolean;
  minValue = 0;
  selectedImage: IImageItem;
  private placeHolderGifts: any;
  placeholderGift: Gift;
  errorMessage: string;
  editMode: boolean;
  emptyTitle = false;
  savingText: string;
  saveText: string;
  loadingImages = false;
  imageQuery: string;
  showLocation = false;
  sectionName = null;
  unSplashImages: Result[];
  skipHelp = false;
  private noMorePages = false;
  showQuery = true;
  private pageNo = 1;
  private sub: any;
  private showPopup: boolean;
  private subject: Subject<string> = new Subject();
  imageText = '';
  fromDuplicate = false;
  selectedFiles: FileList | null;
  forceShowHelp = false;
  subscription: ISubscription;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  defaultPrice: number = undefined;
  processing = false;
  showCropper = false;
  editText = "edit";
  translationError = false;
  canSeeLoops = true;
  regLangUpdated = false;
  customGiftText = false;
  portionTotal: number;
  unCroppedImageUrl = '';
  fromGiftTemplates = false;
  amountToGive: number;
  giftTemplates: Array<Gift>;
  
    portionsRemaining: number;
  portionsRemainingArray: number[];
  selectedPortions: number;
  giftDescriptionTemplates: { label: string, description: string }[] = [
    // { label: 'Excited', description: 'sdfdsfdserwe'},

    { label: 'Meaningful', description: 'Your love is the greatest gift of all. If you would like to help us celebrate with a contribution, we would be honored.' },
    { label: 'Optional', description: 'Your presence in our lives is gift enough. However, should you wish to contribute, we would truly appreciate it.' },
    // { label: 'Casual', description: '33fdsfds'},
    { label: 'Hopeful', description: 'In these uncertain times, our love shines the brightest. Please help us create a lifelong memory.' },
  ];
  previousGiftDescription: string;


  private ngUnsubscribe: Subject<void> = new Subject();

  options = {
    types: ['(regions)']
  };
  anonymousCoupleMode: boolean = false;
  actualPaidPercent: number;
  settings: Settings;


  onKeyUp(searchTextValue: string) {
    // this.imageText = "";
    this.showQuery = false;
    this.subject.next(searchTextValue);
  }

    portionUpdated(e){
    this.amountToGive= this.gift.price * this.selectedPortions;
    //this.updateGiftedPrice(this.giftSelection.price);
    //this.portionsRemainingArray = 
  }

  constructor(
    private _fb: FormBuilder,
    private http: Http,
    private validatorService: CustomValidatorsService,
    private registryService: RegistryService,
    private router: Router,
    private zone: NgZone,
    private _configuration: ConfigurationService,
    private _unsplashImageService: UnsplashImageService,
    private route: ActivatedRoute,
    private _userService: UserService,
    private _analyticsService: AnalyticsService,
    private _registryFirebaseService: RegistryFirebaseService,
    private _authService: AuthService,
    private _intercom: Intercom,
    private _uploadService: UploadService,
    private _settingsService: SettingsStateStore
  ) {

    this.giftTemplates = new Array<Gift>();
    window.scrollTo(0, 0);

    
    if(location.search.includes('isDuplicate')){
      this.fromDuplicate = true;
      this.editText = "Customize"
    } else {
      this.fromDuplicate = false;
      this.editText = "Edit"
    }


this.initMasterGiftList();



    document.title = 'Add Gifts | Hitchd';
    this._authService.user.takeUntil(this.ngUnsubscribe).subscribe(user => {
      if (user) {
        this.user = user;
        this._registryFirebaseService.initGiftsForUser(user);
        this._registryFirebaseService
          .registryForUser(user)
          .takeUntil(this.ngUnsubscribe)
          .subscribe(registry => {
            this.registry = registry;
;
            if(this.settings && this.settings.enableTranslations && this.settings.secondLanguage){
              this.registry.translationLanguage = this.settings.secondLanguage;
            } else if(this.registry && this.registry.translationLanguage && this.settings && !this.settings.enableTranslations) {
              //this.registry.translationLanguage = null;
              
            }
            this.canSeeLoops = registry && (!registry.paid || registry.tier != 'small')
            this.defaultPrice = registry.defaultGiftPrice;
          });
        this.loaded = true;
      }
    });

    this.processing=false;


  }
  ngOnChanges(): void {
    
  }


  
  emitGiftFormUpdates(){
  
  
    this.registryService.setWebsiteUrl(this.gift);
  
    // If price is not empty - but hideprice is true, set hideprice to false
    if (this.gift.price &&  this.gift.hidePrice){ 
      this.gift.hidePrice = false;      
      this.gift.remaining = this.gift.price;
    }
  
    // If paidAmount is empty, set remaining amount to price

    if(!this.gift.paidAmount){
      this.gift.remaining = this.gift.price; 
    }
  
    this.calculatePortions();
this.calculateGiftPricesRemaining();
  }
  
  calculatePortions() {
    // If the gift has portions, calculate the remaining portions 
    if (this.gift.portions) { 
      this.portionsRemainingArray = this.getPortionNumbersArray(this.gift.portions);
      this.portionsRemaining = this.calculatePortionsRemaining(this.gift);
  
      // Calculate paid percent
      if(this.gift.paidPercent){
        this.gift.paidPercent = this.gift.paidAmount / (this.gift.price * this.gift.portions) * 100; 
      }
    }
  }
  getFormDebugInfo() {
    if (!this.hitchdForm) return {};
    
    const debug = {
      formValid: this.hitchdForm.valid,
      formTouched: this.hitchdForm.touched,
      formErrors: this.hitchdForm.errors,
      controls: {}
    };
  
    Object.keys(this.hitchdForm.controls).forEach(key => {
      const control = this.hitchdForm.get(key);
      debug.controls[key] = {
        valid: control.valid,
        touched: control.touched,
        errors: control.errors,
        value: control.value
      };
    });
  
    return debug;
  }
  calculateGiftPricesRemaining  (){
    this.errorMessagePrice = null;
     if(this.gift.portions){return;}

     if(this.gift.paidPercent){
      let paidAmount = this.oldPrice - this.gift.remaining;
      
      this.gift.paidAmount = paidAmount;
      //this.gift.paidPercent = this.gift.paidAmount / (this.gift.price ) * 100; 
      if (this.gift.paidPercent > 100 && this.gift.price>= 1) {
        this.gift.paidPercent = 100;
        let paidAmount = this.oldPrice - this.gift.remaining;
        
        this.errorMessagePrice = "Gift total must higher than the amount previously received "+ this.registry.symbol+paidAmount;
      }

     
   
    } 
  }
  
  getPortionNumbersArray(totalPortions: number): number[] {
    return Array(totalPortions).fill(0).map((portionIndex, portionNumber) => portionNumber + 1); 
  }
  
  calculatePortionsRemaining(gift: Gift): number {
    return Math.floor(((gift.pricePerPortion * gift.portions) - gift.paidAmount)/gift.pricePerPortion ); 
  }
  
  addTranslation(){

    if(this.gift && this.settings){
      ;
    this.gift.showTranslation=!    this.gift.showTranslation; 

      if(!this.gift.showTranslation){
        this.translationError = false;
      }


    if(!this.gift.showTranslation && this.registry.translationLanguage == 'English'){
      this.registry.translationLanguage = null;
      this.gift.showTranslation = false;
    } else if( this.gift.showTranslation && !this.registry.translationLanguage) {
    this.registry.translationLanguage = "English"
    }

    if(this.settings && this.settings.enableTranslations && this.settings.secondLanguage && this.gift.showTranslation){
      this.registry.translationLanguage = this.settings.secondLanguage;
      this.gift.showTranslation = false;
    }
  }
    //this.gift.title ='test111 isuru'
    //this.hitchdForm.controls['titleTranslation'].setValue(this.gift.title);
    //this.gift.titleTranslation = this.gift.title;
    //this.gift.descriptionTranslation = this.gift.description;
    //this.hitchdForm.controls['descriptionTranslation'].setValue(this.gift.description);
  }
  langChanged(){
    this.regLangUpdated = true;
    if (this.registry.translationLanguage != "English"){
      this.translationError = false;
    }
    console.log('lang changed')
  }

  initMasterGiftList(){


    let masterGiftTemplateString = localStorage.getItem('template-gifts');
    // if (starterRegistryString) {
    //   this.registryService.getStarterRegistryTemplates();
    // }
    if (masterGiftTemplateString) {
      this.registryService.getGiftTemplates();
    }
    //this.starterRegistries = JSON.parse(starterRegistryString);
    this.masterGiftTemplates = JSON.parse(masterGiftTemplateString);
  }

  toggleVideo(videoImage: Image) {

    var videobuttons: any = document.getElementsByClassName('video_button');

    var videos: any = document.getElementsByClassName('pexels_video');
    var pausebuttons: any = document.getElementsByClassName('paused');
    var playingButtons: any = document.getElementsByClassName('playing');
    if (videobuttons) {
      Array.from(videobuttons).forEach(element => {
        (element as any).style.display = "none";

      });
    }
    if (pausebuttons) {
      Array.from(pausebuttons).forEach(element => {
        (element as any).style.display = "block";

      });
    }

    if (playingButtons) {
      Array.from(playingButtons).forEach(element => {
        (element as any).style.display = "none";

      });
    }







    var videoPlayer: any = document.getElementById(videoImage.videoUrl);

    var addButton: any = document.getElementById(videoImage.videoUrl + '_add');
    var currentPausebutton: any = document.getElementById(videoImage.videoUrl + '_pause_button');
    var currentPlayButton: any = document.getElementById(videoImage.videoUrl + '_play_button');
    if (videoPlayer.paused) {
      if (videos) {
        Array.from(videos).forEach(element => {

          (element as any).pause();
       //     (element as any).classList.add("paused");
        });
      }

      videoPlayer.play();

      if (currentPausebutton) {
        (currentPausebutton as any).style.display = "block";
      }
      if (currentPlayButton) {
        (currentPlayButton as any).style.display = "none";
      }
      if (addButton) {
        (addButton as any).style.display = "block";
      }

    }
    else {
      videoPlayer.pause();
      if (currentPausebutton) {
        (currentPausebutton as any).style.display = "none";
      }
      if (currentPlayButton) {
        (currentPlayButton as any).style.display = "block";
      }
      if (addButton) {
        (addButton as any).style.display = "none";
      }

    }
    // videoPlayer.classList.add("playing");


  }


  imgixCroppedPrams(event: any) {
    this.gift.cropParams = event;

  }

  saveCroppedImage() {

    this._uploadService.pushUploadBase64(this.croppedImage);
  }


  clearGift() {
    const blankGift = this.generateGift('', 0, '', '', '', '');
    this.setTemplate(blankGift);

 
  }

  openUploader() {
    document.getElementById('file_input_id').click();
  }

  removeNonDigits(priceInput: any) {
    if (!priceInput.value) {
      if (this.gift) {
        this.gift.price = null;
        const priceInpitValue: any = document.getElementById('price');
        priceInpitValue.value = null;
        this.hitchdForm.controls['price'].setValue(this.gift.price);
      }
    }
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setGiftDescription(giftDesscriptionTemplate: any) {
    if (this.customGiftText) {
      this.previousGiftDescription = this.gift.description;

    }
    this.gift.description = giftDesscriptionTemplate.description;
    this.customGiftText = false;
  }
  setGiftType(type) {



    this.giftTypeSelection = type;
    this.hitchdForm.controls['price'].setValue(null);
    this.hitchdForm.controls['hidePrice'].setValue(false);
    this.gift.price = null;
    this.gift.hidePrice = false;
    this.gift.price = null;
    this.gift.location = null;
    this.hitchdForm.controls['location'].setValue(null);

    if (this.giftTypeSelection === 'Cash Fund') {
      this.gift.hidePrice = true;
      this.hitchdForm.controls['hidePrice'].setValue(this.gift.hidePrice);

      ;
      this.hitchdForm.controls['price'].setValue(99999);
      this.gift.price = 99999;
      this.hitchdForm.controls['price'].markAsDirty();
      this.hitchdForm.controls['price'].markAsTouched();
    }

    this.hitchdForm.controls['showGiftAmount'].setValue(this.gift.showGiftAmount);


    if (this.giftTypeSelection === 'Cash Fund') {
      this.setImageByUrl('https://images.unsplash.com/photo-1580562491167-b0865b9d234e?hex=#DEE0DF', 'DEE0DF');
    }
    if (this.giftTypeSelection === 'Gift') {
      this.setImageByUrl('https://images.unsplash.com/photo-1556909114-a1d34f47412c?hex=#B8BEC0', 'B8BEC0');
    }
    if (this.giftTypeSelection === 'Experience') {
      this.setImageByUrl('https://images.unsplash.com/photo-1604156788856-2ce5f2171cce?hex=#AAB4AE', 'AAB4AE');
    }

  }

  ngAfterContentInit(): void {
    if (this.hitchdForm) {
      const textarea: HTMLTextAreaElement = <HTMLTextAreaElement>(
        document.getElementById('textDescription')
      );
      if (textarea) {
        textarea.value = textarea.value + '';
        this.expandTextArea(textarea);
      }
    }
  }

  expandTextArea(textArea: HTMLTextAreaElement) {
    // textArea.rows = 1;
    // const height = textArea.scrollHeight;
    // textArea.rows = Math.floor(height / 26); // 20px = line-height: 1.25rem
    this.customGiftText = true;
    //
  }

  close() {
    this.selectingImage = false;
  }
  showImagePopup() {
    this.selectingImage = true;
    if (this.imageQuery) {
      this.onKeyUp(this.imageQuery);
    } else {
      this.clearQuery('imagesearch');
    }
  }

  fileChangeEvent(event: any): void {

    this.imageChangedEvent = event;
  }

  imageLoaded() {
  
    console.log('Image loaded');
  }



  clearImage() {
    this.gift.imageUrl = null;
    this.hitchdForm.controls['imageUrl'].setValue(null);
  }

  handledUploadedImage(event: any) {
    if (event) {
      event = event + '?hex=ffffff';
      if (this.hitchdForm) {
        this.hitchdForm.markAsTouched();
        if (this.gift.cropParams) {
          this.gift.cropParams = null;
        }
        this.gift.imageUrl = event;
        this.gift.videoUrl = null;
        this.hitchdForm.controls['imageUrl'].setValue(event);
        this.selectingImage = false;


      }
    }
  }

setFieldsFromType(type){


  this.showWebsite = false;
  this.showLocation = false;
  this.gift.type = type;
  
  switch (type){
    case  'experience': {
      this.showLocation = true;
      if(this.gift && !this.gift.id){
        this.toggleHidePrice(false);
      }
      break;
    }
    case  'fund': {
      this.showLocation = true;
      if(this.gift && !this.gift.id){
      this.toggleHidePrice(true);
      }
      break;
    }   
     case  'deposit': {
      this.showLocation = false;
      if(this.gift && !this.gift.id){
      this.toggleHidePrice(true);
      }
      break;
    }
    case  'charity': {
      this.showWebsite = true;
      if(this.gift && !this.gift.id){
      this.toggleHidePrice(true);
      }
      break;
    }
    case  'product': {
      this.showWebsite = true;
      if(this.gift && !this.gift.id){
      this.toggleHidePrice(true);
      }
      break;
    }
    default: {}
  }

}

  arrayUnique(array: Result[]) {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
      for (let j = i + 1; j < a.length; ++j) {
        if (a[i].id === a[j].id) {
          a.splice(j--, 2);
        }
      }
    }

    return a;
  }

  toggleShowGiftAmount() {
    this.gift.showGiftAmount = !this.gift.showGiftAmount;
    this.hitchdForm.controls['showGiftAmount'].setValue(this.gift.showGiftAmount);
  }

  toggleHidePrice(value: boolean) {
    
    this.gift.hidePrice = value;
    this.hitchdForm.controls['hidePrice'].setValue(this.gift.hidePrice);

    if (this.gift.hidePrice) {
      this.hitchdForm.controls['showGiftAmount'].setValue(false);
      this.gift.showGiftAmount = false;
      this.hitchdForm.controls['price'].setValue(null);
      this.gift.price = null;
      this.gift.portions = null;
      this.gift.pricePerPortion = 0;
      this.hitchdForm.controls['price'].markAsDirty();
      this.hitchdForm.controls['price'].markAsTouched();
      this.hitchdForm.markAsDirty();
    } 
    // else if ((this.gift.paidPercent && !this.previousGift.hidePrice) || (this.previousGift &&( this.previousGift.portions || !this.previousGift.hidePrice))){
    //   this.revertGift();
    // }
    else {


      this.portionTotal = 0;
      this.gift.price = null;
      this.hitchdForm.controls['price'].setValue(null);
      this.hitchdForm.controls['price'].markAsPristine();
      this.hitchdForm.controls['price'].markAsUntouched();
 
    }

  }



  backToGift() {
    this.router.navigate(['/registry', this.gift.friendlyUrl]);
  }

  back() {
    history.back();
  }
  clearQuery(elementId: string) {

    if (!elementId) {
      elementId = 'imagesearch';
    }

    this.imageQuery = '';
    this.onKeyUp('');
    document.getElementById(elementId).focus();
  }

  setTemplate(template: Gift) {
    
    Object.assign(this.gift, template);
    // giftTemplateName
    this.gift.location = null;
    this.hitchdForm.controls['location'].setValue(null);
    
    this.searchType = "Photos";
    ;
    this.hitchdForm.controls['price'].setValue(this.gift.price);
    this.hitchdForm.controls['price'].markAsDirty();
;
    if (this.gift.hidePrice) {
      this.gift.price = null;
    }


    if (this.gift.title) {

      this.hitchdForm.controls['title'].markAsDirty();
      this.hitchdForm.markAsTouched();
    }


    this.registryService.selectedGift = null;
    
    this.hitchdForm.controls['imageUrl'].setValue(this.gift.imageUrl);
    this.unCroppedImageUrl = this.gift.imageUrl;
    this.hitchdForm.controls['imageUrl'].markAsDirty();
    this.hitchdForm.controls['title'].setValue(this.gift.title);
    this.hitchdForm.controls['title'].markAsDirty();
    this.showLocation = false;
    if (this.gift.location) {
      this.hitchdForm.controls['location'].setValue(this.gift.location);
      this.hitchdForm.controls['location'].markAsDirty();
      this.showLocation = true;
    }
    this.hitchdForm.controls['description'].setValue(
      this.gift.description
    );

    this.hitchdForm.controls['showGiftAmount'].setValue(this.gift.showGiftAmount);
    this.hitchdForm.controls['showGiftAmount'].markAsDirty();
    this.hitchdForm.controls['featuredGift'].setValue(this.gift.featuredGift);
    this.hitchdForm.controls['featuredGift'].markAsDirty();


    this.giftTypeSelection = this.gift.giftTypeSelection;
    this.imageQuery = this.gift.title;

    this.hitchdForm.controls['createdFromGiftAssistant'].setValue(this.gift.createdFromGiftAssistant);
    this.hitchdForm.controls['editedAfterGiftAssistant'].setValue(this.gift.editedAfterGiftAssistant);

    
    if(this.gift.showTranslation || (this.registry && this.registry.translationLanguage)){
     this.gift.showTranslation = true;
    }

    
    if (this.gift.description) {
      this.hitchdForm.controls['description'].markAsDirty();

    }
    // this.toggleHidePrice(this.gift.hidePrice);
    if (this.imageQuery) {
      this.onKeyUp(this.imageQuery);
    }
    this.hitchdForm.markAsTouched();
  

  }

  findImages(loadFirst: boolean) {
 
    if(   this.noMore){
      return;
    }
    if (this.searchType == 'Loops' && this.registry && this.registry.paid && this.registry.tier == 'small') {

      return;
    }

    if (this.searchType == 'Loops' && !this.imageQuery) {
      this.imageQuery = ''
    }

    this.loadingImages = true;

    if (this.pageNo === 1) {
      this.unSplashImages = new Array<Result>();
      this.images = null;;
    }

    let collectionId = '';
    if (!this.imageQuery || this.imageQuery === '') {
      collectionId = '1073977';
    } else {
      this._intercom.trackEvent('find image', {
        'image-query': this.imageQuery
      });
    }
    this.imageText = this.imageQuery;

    if (
      this.imageQuery &&
      this.imageQuery
        .toLowerCase()
        .startsWith('https://images.unsplash.com/photo')
    ) {
      this.setImageViaUrl(this.imageQuery);
    }



    this._unsplashImageService
      .GetUnsplashImages(this.imageQuery, this.pageNo, collectionId, this.searchType === 'Loops')
      .subscribe(imageResults => {


        if (this.pageNo> 1 &&  this.images && imageResults && imageResults.length ){
          this.images = this.images.concat(imageResults);
        }
        else if (this.pageNo> 1 &&  this.images && (!imageResults || !imageResults.length)  ){
          this.noMore = true;
          this.loadingMore = false;
          this.loadingImages = false;
        } 
        
        else {
          this.images = imageResults;
        }

      if(this.loadingMore){
        this.loadingMore = false;
      }
        this.loadingImages = false;

      });
  }
  viewPlansOrUpgrade() {

    if (!this.registry.paid) {
      this.router.navigate(['visibility'])
    }
    else if (this.registry.paid && this.registry.tier != 'full') {
      this.router.navigate(['visibility'])
    }
  }
  scroll(event) {
    if(((event.target.scrollTop +  event.target.offsetHeight)) >= (event.target.scrollHeight * 0.8)){

      if( this.loadingMore ){
        return;
      }

      this.loadingMore = true
      this.loadMore();

     // addCards(currentPage + 1);
    }
  }
  onEnter() {
    document.getElementById('imagesearch').blur();
  }
  loadMore() {
    this.pageNo = this.pageNo + 1;
    this.loadingMore = true;

    this.findImages(false);
  }

  showHelp() {
    this.registryService.emitCreateHelpPopup();
  }

getGiftOrFromTemplate(giftName: string){
  
  if (giftName) {
    if (this.gifts && this.settings){
    this.gift = this.gifts.filter(gifts => gifts.friendlyUrl.toLowerCase() === giftName.toLowerCase())[0];

    if(this.settings && this.settings.enableTranslations && this.settings.secondLanguage){
      this.registry.translationLanguage = this.settings.secondLanguage;
      this.gift.showTranslation = true;
    } else if( this.registry.translationLanguage && this.settings && !this.settings.enableTranslations) {
      this.gift.showTranslation = true;
    }
    else {
      this.gift.showTranslation = false;
    }
    this.actualPaidPercent = this.gift.paidPercent;
    this.fromGiftTemplates = false;  
  }
if (this.gift && this.gift.hidePrice && this.gift.price ){
  this.gift.price = null;
}

    if ((!this.gift || Object.keys(this.gift).length === 0) && location.search.includes('giftTemplateId')){
      
      this.fromGiftTemplates = true;
      this.editMode = true;
      const params = new URLSearchParams(location.search);
      let giftTemplateId = params.get('giftTemplateId');
      this.hitchdForm.markAsTouched();
      
      this.gift = this.masterGiftTemplates.filter(giftTemplate => giftTemplate.id == giftTemplateId)[0]
      
      
   
      this.gift.fromRegistry =  "search-results"
      this.gift.templateGiftId = giftTemplateId;
      this.gift.fromTemplate = true;
      this.gift.friendlyUrl = this.cleanTitleString(this.gift.title)
      this.gift.id = undefined;

      this._analyticsService.trackEvent('View Customize Gift Template' ,{

        title: this.gift.title,
        created_from: 'gift_templates',
        template_id: this.gift.templateGiftId,
        templateName: this.gift.title
      });
   
    }}
    this.initMasterGiftList();

}

  color() {
    return this.registryService.getColor(this.gift.imageUrl);
  }
  ngOnInit() {
    this.gift = new Gift();
    this.gift.title = 'tes';
    this.gifts = this.route.snapshot.data.gifts;
    this.settings = this.route.snapshot.data.settings;
    this.registry = this.route.snapshot.data.registry;
    const pageUserMode = this.route.snapshot.data.pageUserMode;
    this.route.paramMap.subscribe(params => {
      this.sectionName = params.get('sectionName');
 
    });

    
    if (pageUserMode == 'couple_anon') {
      this.loaded = true;
      this.anonymousCoupleMode = true;
      this._registryFirebaseService.killLoader();

      this.registry = this._registryFirebaseService.getAnonRegistry();
      this.gifts = this._registryFirebaseService.getLocalGifts();
    
    }

    const seenHelpModal = localStorage.getItem('seen_create_help_modal');
    if (!seenHelpModal) {
      this.registryService.emitCreateHelpPopup();
    }
    this.unSplashImages = new Array<Result>();



    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    body.setAttribute('class', '');

    this.route.params.takeUntil(this.ngUnsubscribe).subscribe(params => {
      const giftName = params['gifttitle'];


      this._userService.emitUpdateHeaderType('hidenav');
      this.sub = this.route.data
        .takeUntil(this.ngUnsubscribe)
        .subscribe(data => {
          this.showPopup = data['showPopup'] as boolean;
        });

      this.initCategories();
      this.gift = new Gift();
      this.hitchdForm = this._fb.group({
        id: [null, []],
        category: [null, []],
        imageUrl: ['', [Validators.required]],
        defaultPrice: [],
        title: [
          '',
          [
            this.checkGiftName.bind(this),
            Validators.required,
            Validators.minLength(1),
            Validators.required,
            Validators.maxLength(80)
          ]
        ],
        hidePrice: [''],
        giftTypeSelection: [''],
        location: [''],
        description: [''],
        showGiftAmount: [false],
        price: [''],
        createdFromGiftAssistant: [],
        editedAfterGiftAssistant: [],
        featuredGift: [false],
        portions: [''],
        pricePerPortion: [''],
        website: [''],
        titleTranslation: [''],
        descriptionTranslation: [''],        
      });


      if (giftName) {

       this.getGiftOrFromTemplate(giftName);

        this.previousGift = new Gift();
        if (this.gift) {
          this.setPortions();
          Object.assign(this.previousGift, this.gift);

          this.setTemplate(this.gift);

        }


//        this.hitchdForm.markAsUntouched();

        if (this.gift) {
          document.title = this.gift.title + ' | Hitchd';
        }
        this._intercom.trackEvent('view edit-gift page', { name: giftName });
      } else if (!giftName) {

        this.clearGift();
        this._intercom.trackEvent('view create-gift page');

      }
      


      this.subject
        .debounceTime(850)
        .takeUntil(this.ngUnsubscribe)
        .subscribe(searchTextValue => {
          this.pageNo = 1;
          this.noMore = false;
          this.showQuery = true;

          this.findImages(false);
        });
      this.subscription = this._registryFirebaseService.currentGifts
        .takeUntil(this.ngUnsubscribe)
        .subscribe(gifts => {
          // console.log("create current gifts");
          this.gifts = gifts;

          this.selectingImage = false;

          if (gifts && giftName) {
            
           
            this.getGiftOrFromTemplate(giftName);
     
            if (this.gift) {
              this.oldPrice = this.gift.price;
            this.setPortions();


         
            }
          }
          //  else {
          //             this.gift = new Gift();
          //             this.gift.paidAmount = 0;
          //           }
          this.baseUrl = this._configuration.baseUrl;
          if (!this.gift.id) {
            this.initCreateModeWithPlaceholderGift();
            
          } else {


            this.initEditModeWithGift();
            this.registryService.setWebsiteUrl(this.gift);
            const textarea: HTMLTextAreaElement = <HTMLTextAreaElement>(
              document.getElementById('textDescription')
            );
            if (textarea) {
              textarea.value = textarea.value + '';
              this.expandTextArea(textarea);
            }
          }
        });

        this._settingsService.getState().subscribe(state => {
          this.settings = state.settings;
          
     
        })
    
    });
  }
  openLink(){
    if(!this.gift.website) {
      return;
    }    
    if (this.gift.website.startsWith('http://') || this.gift.website.startsWith('https://')){    
      this._analyticsService.trackEvent('Visit Gift Url', { visit_url:this.gift.website })
    window.open(this.gift.website, '_blank').focus();
    
  } else {
    this._analyticsService.trackEvent('Visit Gift Url', { visit_url: 'https://' + this.gift.website })
    window.open('https://' + this.gift.website, '_blank').focus();
  }
  }
  //  help(step: number) {
  //     this.router.navigate[('/create-gfit/help/1')];
  // }
  help() {
    if (this.editMode) {
      this.registryService.lastEditUrl = this.router.url;
    }
    this.router.navigate(['registry/create-gift/help/1'], {
      skipLocationChange: true
    });
  }

  setPortions(){
    this.oldPrice = this.gift.price;
    if (this.gift.portions) {
  
      this.gift.price = this.gift.pricePerPortion;  
  
      this.portionTotal = this.gift.pricePerPortion * this.gift.portions;      
      this.hitchdForm.controls['price'].setValue(this.gift.price);
      // ;
      // if (this.gift.paidPercent > 0){
   
      //   let totalPaid =  (this.oldPrice * this.gift.paidPercent/100)
      //   let portionsPaid = (this.portionTotal - totalPaid)/ this.gift.pricePerPortion
      //   this.lowestAllowedPortionsToSave = portionsPaid+1;
      //}
    }
  }

  resetSearch() {
    this.imageQuery = '';
  }

  revertGift() {

    Object.assign(this.gift, this.previousGift);

    this.setTemplate(this.gift);

    this.hitchdForm.markAsUntouched();
  }

  checkGiftName(control: AbstractControl) {
    return false;

    // this.titleExists = false;
    // this.emptyTitle = false;
    // if (this.gifts && this.hitchdForm && control && control.value) {
    //   //
    //   let existingGifts = Array<Gift>();
    //   //

    //   if (!this.cleanTitleOnly(control.value)) {
    //     this.hitchdForm.controls['title'].setErrors({
    //       emptyFriendlyUrl: true
    //     });
    //     this.emptyTitle = true;

    //   }
    //   const friendlyUrl = this.cleanTitleString(this.gift.title);
    //   if (this.gift.id) {
    //     existingGifts = this.gifts.filter(
    //       x =>
    //         x.id !== this.gift.id && (
    //           x.title.toLowerCase() === this.gift.title.toLowerCase() ||
    //           x.friendlyUrl.toLowerCase() === friendlyUrl.toLowerCase()));

    //   } else {
    //     existingGifts = this.gifts.filter(
    //       x => x.title.toLowerCase() === this.gift.title.toLowerCase() ||
    //         x.friendlyUrl.toLowerCase() === friendlyUrl.toLowerCase());



    //   }
    //   if (existingGifts.length >= 1) {
    //     this.hitchdForm.controls['title'].setErrors({
    //       titleAlreadyExists: true
    //     });

    //     this.titleExists = true;
    //   }
    // }
  }

  initEditModeWithGift() {
    const imageUrl = this.gift.imageUrl;
    this.editMode = true;
    this.saveText = 'Update';
    this.savingText = 'saving';
    this.loaded = true;
    this.imageQuery = this.gift.title;
    if (this.gift.videoUrl) {
      this.searchType = 'Loops';
    }

    this.setFieldsFromType(this.gift.type);
    this.findImages(false);

    if(this.gift.portions){
      
      //this.pricePerPortion = this.registryService.getPortionsPricePerPortion(this.gift);
      if(this.gift.paidPercent){
        
        
        this.gift.paidAmount = (this.gift.price * this.gift.portions) - this.gift.remaining;

        this.disablePrice = true;
      this.portionsRemaining =  Math.floor(this.gift.remaining /this.gift.pricePerPortion) ;
      } else {
        this.portionsRemaining = this.gift.portions;
      }
      this.portionsRemainingArray = Array(this.portionsRemaining).fill(0).map((x, i) => i + 1);
      this.selectedPortions = 1;    
    } else {
      
      if(this.oldPrice){
      let paidAmount = this.oldPrice - this.gift.remaining;
      this.gift.paidAmount = paidAmount;
      }
      if(this.gift.hidePrice && this.gift.price == null && (99999-this.gift.remaining) > 0){
        this.disablePrice = true;
       
      }

    }

    if(this.settings && this.settings.enableTranslations && this.settings.secondLanguage){
      this.registry.translationLanguage = this.settings.secondLanguage;
      this.gift.showTranslation = true;
    }
  }

  handleAddressChange(location: any) {

    const countryString: string = location.adr_address.split('<span class="country-name">')[1];
    const country = countryString.replace('</span>', '');

    this.gift.location = location.name;
    if (location.name !== country) {
      this.gift.location = location.name + ', ' + country;
    }


    this.hitchdForm.controls['location'].markAsDirty();

    this.hitchdForm.controls['location'].setValue(this.gift.location);
  }


  cleanTitleOnly(title: string) {

    const ranges = [
      '[\u00A0-\u269f]',
      '[\u26A0-\u329f]',
      // The following characters could not be minified correctly
      // if specifed with the ES6 syntax \u{1F400}
      '[🀄-🧀]',
      '[\u{1F004}-\u{1F9C0}]'
    ];
    return title.replace(new RegExp(ranges.join('|'), 'ug'), '').replace(/[^\w\s]/gi, '').replace(/ /g, '-');
  }



  cleanTitleString(title) {

    const ranges = [
      '[\u00A0-\u269f]',
      '[\u26A0-\u329f]',
      // The following characters could not be minified correctly
      // if specifed with the ES6 syntax \u{1F400}
      '[🀄-🧀]',
      '[\u{1F004}-\u{1F9C0}]'
    ];

    return title.replace(new RegExp(ranges.join('|'), 'ug'), '').replace(/[^\w\s]/gi, '').replace(/ /g, '-');


  }


  cleanTitle() {


    this.gift.friendlyUrl = this.cleanTitleString(this.gift.title);


  }


  initCreateModeWithPlaceholderGift() {
    // this.placeHolderGifts = this.registryService.GetCreatePlaceHolders(this.images);
    
    //this.hitchdForm.controls['category'].setValue(this.gift.type);
    //   this.imageQuery = 'hotels';


    this.findImages(false);

    this.editMode = false;
    if (this.saveText !== 'Update') {
      this.saveText = 'Add Gift';
      this.savingText = 'creating';
      this.hitchdForm.controls['title'].markAsPristine();
      this.hitchdForm.controls['title'].markAsUntouched();
      //  this.hitchdForm.controls['title'].markAsDirty();
      this.hitchdForm.controls['location'].markAsPristine();
      // this.hitchdForm.controls['location'].markAsDirty();
      this.hitchdForm.controls['location'].markAsUntouched();
      this.hitchdForm.controls['description'].markAsPristine();
      this.hitchdForm.controls['description'].markAsUntouched();
      // this.hitchdForm.controls['price'].markAsPristine();
      // this.hitchdForm.controls['price'].markAsUntouched();
  
    }
    if(location.search.includes('giftTemplateId')){
      this.editMode = true;
    }
   if (this.gift && !this.gift.type){
    this.gift.type = 'experience';
   }
  if (!this.fromGiftTemplates){
    this.setFieldsFromType(this.gift.type);
  } else {
    if (this.gift.hidePrice && this.gift.price > 80000){
      this.gift.price = null;
    }
  }
   
  }

  clearIfEmpty(fieldName: string) {
    const field = this.hitchdForm.controls[fieldName];
    if (field.pristine && this.placeholderGift) {
      field.setValue('');
      this.hitchdForm.controls[fieldName].setValue(null);
    }
  }
  focusOut(fieldName: string, resetValue: string) {
    const field = this.hitchdForm.controls[fieldName];
    if (field.pristine && this.placeholderGift) {
      this.hitchdForm.controls[fieldName].setValue(resetValue);
    }
  }
  removeDecimals() {
    this.gift.price = parseInt(this.gift.price.toString(), 0);
    this.hitchdForm.controls['price'].setValue(this.gift.price);
  }

  hasFeaturedGifts() {

    if(this.anonymousCoupleMode && !this.gifts){
      this.gifts = this._registryFirebaseService.getLocalGifts();
    }

    const featuredGifts = this.gifts.filter(x => x.featuredGift);
    return featuredGifts.length > 0;
  }

  unfeatureExistinggift() {
    const featuredGifts = this.gifts.filter(x => x.featuredGift);

    if (!this.anonymousCoupleMode) {
    featuredGifts.forEach(gift => {
      gift.featuredGift = false;
      return this._registryFirebaseService.updateGift(gift);
    });
  } else {
    featuredGifts.forEach(gift => {
      gift.featuredGift = false;
      return this._registryFirebaseService.updateGiftLocally(gift);
    });
  }
  }


  save() {
    this.errorMessagePrice = "";
    this.translationError = false;
    this.disablePrice = false;

if(this.registry.translationLanguage == "English"){
  this.translationError = true;
  return;
}

if(!this.registry.introductionTextTranslation && this.registry.translationLanguage && !this.gift.showTranslation){
  this.registry.translationLanguage = null;
  this.regLangUpdated = true;
  this.gift.showTranslation = true;
}

if(this.regLangUpdated && !this.anonymousCoupleMode){
  this._registryFirebaseService.updateReg(this.registry)
}

    if (!this.gift.price){    
      this.disablePrice = true;
      this.toggleHidePrice(true)
      this.gift.price = 99999;
      this.hitchdForm.controls['price'].setValue(    this.gift.price );
    } else if (this.gift.price && this.gift.hidePrice){
      this.gift.hidePrice = false;
      this.hitchdForm.controls['hidePrice'].setValue(    false);
    }

    this.subscription.unsubscribe();
    if (this.hitchdForm.invalid) {
      this.processing=false;
      return;
    
    }
    this.processing=true;
    if (this.hitchdForm.value['featuredGift'] == true && this.hasFeaturedGifts()) {
      this.unfeatureExistinggift();
    }

    this.cleanTitle();


    this.submitting = true;
    this.removeDecimals();
    this.hitchdForm.value['hidePrice'] = this.gift.hidePrice;

    // if(this.gift.hidePrice){
    //   this.disablePrice = true;
    // }

    if (this.defaultPrice !== this.registry.defaultGiftPrice) {
      this.registry.defaultGiftPrice = this.defaultPrice;
      this._registryFirebaseService.updateReg(this.registry);
    }

    // if(this.registry.utm)
    // this.hitchdForm.value['defaultPrice'] = null;

    if (this.giftTypeSelection) {
      this.hitchdForm.value['giftTypeSelection'] = this.giftTypeSelection;
    }
    ;
    if (this.gift.portions) {
      this.disablePrice = true;
      this.hitchdForm.value['pricePerPortion'] = this.gift.price;
      this.hitchdForm.value['price'] = this.gift.price * this.gift.portions;
      this.gift.pricePerPortion =  this.gift.price;
      this.gift.price = this.gift.price * this.gift.portions;

    } else {
      this.hitchdForm.value['pricePerPortion'] = 0;
      this.gift.pricePerPortion =  0;
      
      
    }
    
    if (this.gift.id) {

      let paidAmount = 0 ;
      
      if(this.gift.paidPercent){
      paidAmount = this.oldPrice - this.gift.remaining;
      
      }
      // const editGift: Gift = this.hitchdForm.value;
      // editGift.id = this.gift.id;
      // if (this.gift.cropParams) {
      //   editGift.cropParams = this.gift.cropParams;
      // }
      this.gift.registryId = this.registry.id;
      // if (!editGift.friendlyUrl) {
      //   editGift.friendlyUrl = this.gift.friendlyUrl;
      // }
      this.hitchdForm.value['defaultPrice'] = null;
      
       let remaining = 0;
      
      if (this.gift.portions && paidAmount){
        remaining = (this.gift.portions * this.gift.pricePerPortion) - paidAmount;
      } else if(paidAmount) {
        remaining = this.gift.price - paidAmount;
      } else if (!this.gift.portions && !paidAmount){
        remaining = this.gift.price;
      } else if (this.gift.portions && !paidAmount){
        remaining= this.gift.portions * this.gift.pricePerPortion;
      }

      if (remaining <= 0){
      this.errorMessagePrice = "Gift total must higher than the amount previously received "+this.registry.symbol+paidAmount;
      if(this.gift.portions){
        this.gift.price = this.gift.pricePerPortion;
      }
      this.disablePrice = false;
      this.submitting = false;
      this.processing = false;
      return;
      }
      this.gift.remaining = remaining;
;
      if(this.gift)

      this.gift.showGiftAmount = this.hitchdForm.value['showGiftAmount'];
      this.gift.featuredGift = this.hitchdForm.value['featuredGift'];
      // if (editGift.createdFromGiftAssistant) {
      //   editGift.editedAfterGiftAssistant = true;
      // }

      if(this.anonymousCoupleMode){
        this._registryFirebaseService.updateGiftLocally(this.hitchdForm.value as Gift)
      
        //if(location.search.includes('giftTemplateId')){
         // this.registryService.emitToastType(ToastType.);
       return   this.router.navigate(['/your-registry']);
      
       } else {

      this._registryFirebaseService.updateGift(this.gift).then(x => {
        localStorage.removeItem('giftSelection');
        // this.router.navigate([
        //   '/registry/'
        //   , this.gift.friendlyUrl
        // ]);


        this._analyticsService.trackEvent('Gift Edited', {
          ...this.gift
                 
          
        });

        if(location.search.includes('giftTemplateId')){
          this.registryService.emitToastType(ToastType.createdGift);
          this.router.navigate(['/registry/templates']);
      
        } else {
          this.registryService.emitGenericToastMsg("Gift updated");
        this.handleRedirectAfterEditOrSaveGift(this.gift);
        }

        
      });

    }

    } else {


      if (this.gift.hideFundingProgress !== undefined) {
        this.hitchdForm.value['hideFundingProgress'] = this.gift.hideFundingProgress;
      }

      if (this.gift.mustBuyEntireGift!== undefined) {
        this.hitchdForm.value['mustBuyEntireGift'] = this.gift.mustBuyEntireGift;
      }

      if (this.gift.showTranslation !== undefined) {
        this.hitchdForm.value['showTranslation'] = this.gift.showTranslation;
      }

     
      if (this.registry.source) {
        this.hitchdForm.value['source'] = this.registry.source;
      }
      if (this.registry.partnershipId) {
        this.hitchdForm.value['partnershipId'] = this.registry.partnershipId;
      }
      if (this.registry.campaign) {
        this.hitchdForm.value['campaign'] = this.registry.campaign;
      }
      this.hitchdForm.value['friendlyUrl'] = this.gift.friendlyUrl;
      if (this.gift.cropParams) {
        this.hitchdForm.value['cropParams'] = this.gift.cropParams;
      }
      this.hitchdForm.value['defaultPrice'] = null;
      this.hitchdForm.value['videoUrl'] = this.gift.videoUrl;
      this.hitchdForm.value['portions'] = this.gift.portions;

      if(this.gift.type){
        this.hitchdForm.value['type'] = this.gift.type;
        }
      if(this.gift.fromRegistry){
      this.hitchdForm.value['fromRegistry'] = this.gift.fromRegistry;
      }
      if(this.gift.templateGiftId){
        this.hitchdForm.value['templateGiftId'] = this.gift.templateGiftId;
        }
        if(this.gift.fromTemplate){
          this.hitchdForm.value['fromTemplate'] = this.gift.fromTemplate;
          }

      Object.keys(this.hitchdForm.value).forEach(key => this.hitchdForm.value[key] === undefined && delete this.hitchdForm.value[key]);


      if(this.anonymousCoupleMode){
        this._registryFirebaseService.addGiftLocally(this.hitchdForm.value as Gift)

        if(location.search.includes('giftTemplateId')){
          this.registryService.emitToastType(ToastType.createdGift);
          this.router.navigate(['/create-registry']);
      
        } else {
        this.handleRedirectAfterEditOrSaveGift(this.gift);
        }


      } else {
        let newGift: Gift = this.hitchdForm.value;
      this._registryFirebaseService
        .addGift(newGift, this.registry)
        .then(x => {


          localStorage.removeItem('giftSelection');
          // this._registryFirebaseService
          
          let created_from = 'create_gift_page';
          if(      this.gift.templateGiftId){
            created_from = 'gift_templates';
          }
          this.gift.giftTypeSelection = this.giftTypeSelection;
          console.log(7)
          this._analyticsService.trackEvent('Gift Created', {
            created_from: created_from,
            is_edit_template: created_from == 'gift_templates',
            ...this.gift,     
          });


          if(this.sectionName){
            
      this._registryFirebaseService.addGiftIdToSection(this.sectionName, this.registry, newGift.id);
     }console.log(6)
          this.registryService.sendFbTrackEvent('Gift created');

          if(location.search.includes('giftTemplateId')){
            this.registryService.emitToastType(ToastType.createdGift);
            this.router.navigate(['/registry/templates']);
        
          } else {
            this.registryService.emitToastType(ToastType.createdGift);
          this.handleRedirectAfterEditOrSaveGift(this.gift);
          }
        });
      }




    }



  }

  exit(){
    if(this.anonymousCoupleMode){
      return this.router.navigate(['/your-registry']);
    } else {
      return this.router.navigate(['/registry']);
    }
  }

  handleRedirectAfterEditOrSaveGift(gift: Gift) {
    const created_first_gift = localStorage.getItem('created_first_gift');
    this.processing=false;
    this.submitting = false;
    if (!created_first_gift) {

      localStorage.setItem('first_gift_url', this.gift.friendlyUrl);
      localStorage.setItem('created_first_gift', 'true');
      localStorage.setItem('first_gift_name', this.gift.title);
      localStorage.setItem('first_gift_image', this.gift.imageUrl);
      let hasSeenPopup = localStorage.getItem('seen_first_gift_success');
      if(this.anonymousCoupleMode && !hasSeenPopup){
        return this.router.navigate(['/your-registry']);
      }
      return this.router.navigate(['/registry/how-contributions-work']);
      
    }
    else {
      // localStorage.setItem('toast_' + ToastType.createdGift, 'true');
      // this.registryService.emitToastType(ToastType.createdGift);

      if(this.anonymousCoupleMode){
        return this.router.navigate(['/your-registry']);
      } else {
        this.router.navigate(['/registry']);
      }
    
   

    }
  }
  generateGift(
    title,
    price: number,
    hex: string,
    description,
    imageUrl,
    category,
    videoUrl = null
  ): Gift {
    const gift = new Gift();
    ;
    gift.price = price;
    // if (location) {
    //   gift.location = location;
    // }
    ;
    gift.hidePrice = false;
    // if (gift.price === 0) {
    //   gift.hidePrice = true;
    //   gift.price = 99999;
    // }

    gift.hex = hex;
    gift.description = description;
    gift.title = title;
    gift.imageUrl = imageUrl;
    gift.videoUrl = videoUrl;
    gift.category = category;
    gift.createdFromGiftAssistant = false;
    gift.editedAfterGiftAssistant = false;
    gift.giftTypeSelection = 'Gift';
    return gift;
    //  return JSON.parse(JSON.stringify(gift));
  }

  top() {
    document.getElementById('imagesearch').focus();
  }
  handleKeyboardEvents(event: any) {
  }
  giftImageClicked(event: any) {
    this.selectingImage = true;
  }
  onCategoryChange(event: Event) {
    this.hitchdForm.markAsTouched();
    this.initCreateModeWithPlaceholderGift();
  }
  selectImage() {
    const image = this.hitchdForm.controls['imageUrl'];
    image.markAsDirty();
    image.markAsTouched();
    this.selectingImage = true;
  }
  changePortion(numberChange: number) {
    if (this.gift.portions == 1 && numberChange == -1) {
      this.portionTotal = this.gift.price;
      return;

    }
    this.hitchdForm.markAsTouched();
    this.gift.portions = this.gift.portions + numberChange;
    this.portionTotal = this.gift.price * this.gift.portions;
    this.emitGiftFormUpdates()
  }

  togglePortions() {
    if(this.gift.portions && this.gift.paidAmount && this.previousGift.portions){
      return;
    }

    if (this.gift.portions && this.gift.portions >= 1) {
      this.gift.portions = 0;

      this.hitchdForm.markAsTouched();
    } else {
      this.hitchdForm.markAsTouched();
      this.gift.portions = this.gift.portions = 1;

      this.selectedPortions = 1;
      this.portionUpdated(null);
      this.portionTotal = this.gift.price * this.gift.portions;
    }


  }
  toggleFundingProgress(){
    if(!this.gift.hideFundingProgress){
      this.gift.hideFundingProgress = true;
    } else {
      this.gift.hideFundingProgress = false
    }
    this.hitchdForm.markAsTouched();
  }
  toggleMustBuyEntireGift(){

    if(!this.gift.mustBuyEntireGift){
      this.gift.mustBuyEntireGift = true;
    } else {
      this.gift.mustBuyEntireGift = false
    }
    this.hitchdForm.markAsTouched();
  }
  updatePortion() {
    if (this.gift.portions) {
      this.portionTotal = this.gift.price * this.gift.portions;
    }
    this.gift.pricePerPortion = this.gift.price;
    this.portionsRemainingArray = new Array<number>();
    this.portionsRemainingArray = Array(this.gift.portions).fill(0).map((x, i) => i + 1);
    // let tempGift:Gift = {...this.gift}
    // tempGift.price = this.portionTotal;
    // this.registryService.emitGiftFormUpdates(this.gift);
  }

  hidePortions() {
    this.gift.portions = 0; this.portionsRemainingArray = null;
  }

  setImageViaUrl(imageUrl: string) {
    this.hitchdForm.controls['imageUrl'].setValue(imageUrl);
    this.selectingImage = false;
    this.gift.imageUrl = imageUrl;
  }

  getGiftUrlWithoutHex() {
    if (this.gift && this.gift.imageUrl) {
      return this.registryService.cleanImageUrlRemoveHex(this.gift.imageUrl);
    } else {
      return '';
    }
  }



  getImage(imageUrl: string) {
    return this.http
      .get(imageUrl, { responseType: ResponseContentType.Blob })
      .map(x => {

        const blob = x.blob();


        const reader = new FileReader();

        reader.readAsDataURL(blob);
        reader.onloadend = (e: any) => {

          this.selectedimageBase64 = e.result;
          // console.log(e.result);
        };
        this.imageChangedEvent = x;

      });
  }

  setImageByUrl(imageUrl: string, hex: string) {
    this.hitchdForm.controls['imageUrl'].setValue(imageUrl);
    this.gift.hex = hex;
    this.gift.imageUrl = imageUrl;
  }

  setImage(image: Image) {

    this.gift.videoUrl = null;

    if (this.gift.cropParams) {
      this.gift.cropParams = null;
    }

    if (this.selectingImage) {
      this.previousImage = this.selectedImage;
    }

    if (image && image.analyticsUrl) {
      this._unsplashImageService.SendDownloadRequest(
        image.analyticsUrl
      );
    }
    this.hitchdForm.markAsTouched();
    this.hitchdForm.controls['imageUrl'].setValue(
      image.imageUrl + '?hex=' + image.color
    );


    this.gift.imageUrl = image.imageUrl + '?hex=' + image.color

    this.gift.hex = image.color;
    this.category = this.imageQuery;
    this.selectingImage = false;

    if (!this.gift.title) {
      document.getElementById('giftTitle').focus();
    }
    if (image.videoUrl) {
      this.gift.videoUrl = image.videoUrl;
    }
  }
  cancelGift() {
    this.selectingImage = false;
    // if (this.previousImage) {
    //     this.setImage(this.previousImage);
    // }
  }
  initCategories() {
    this.categories = new Array<string>();
    this.categories.push('Accommodation');
    this.categories.push('Activity');
    this.categories.push('Dining');
    this.categories.push('Experience');
    this.categories.push('Other');
    this.categories.push('Transport');
  }
  cleanImageUrl() {
    if (this.gift && this.gift.imageUrl)
      return this.registryService.cleanImageUrlRemoveHex(this.gift.imageUrl);
  }
  cleanIntField() {
    const test = this.gift.price;
    const test2 = this.hitchdForm.controls['price'].value;
  }
  navigateCategory(back: boolean) {
    let categoryIndex = this.categories
      .map(x => x.toLowerCase())
      .indexOf(this.category);
    if (back) {
      if (categoryIndex === 0) {
        categoryIndex = this.categories.length - 1;
        this.category = this.categories[categoryIndex];
      } else {
        this.category = this.categories[categoryIndex - 1];
      }
    } else {
      if (categoryIndex === this.categories.length - 1) {
        categoryIndex = 0;
        this.category = this.categories[categoryIndex];
      } else {
        this.category = this.categories[categoryIndex + 1];
      }
    }
    this.category = this.category.toLocaleLowerCase();
    this.hitchdForm.controls['category'].setValue(this.imageQuery);
    this.initCreateModeWithPlaceholderGift();
  }
}



// WEBPACK FOOTER //
// ./src/app/create-gift/create-gift.component.ts